import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Button, Checkbox } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useContext } from 'react';
import CardBlock from '@/components/CardBlock/CardBlock';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useForm } from 'react-hook-form';
import * as _ from 'underscore';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECCheckboxField } from '@/components/Forms/ECCheckboxField';
import { Link, useParams } from 'react-router-dom';
import { AppContext } from '@/AppContext';

import { ECQuillEditor } from '@/components/Forms/ECQuillEditor';
import ReactQuill from 'react-quill-new';
import Chip from '@mui/material/Chip';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { AttachmentsList } from './AttachmentsList';

const PREFIX = 'RegFormMail';

const classes = {
  groupLabel: `${PREFIX}-groupLabel`,
  editor: `${PREFIX}-editor`,
  spacing: `${PREFIX}-spacing`,
};

const StyledCardBlock = styled(CardBlock)(({ theme }) => ({
  [`& .${classes.groupLabel}`]: {
    paddingTop: 12, //theme.spacing(1)
  },

  [`& .${classes.editor}`]: {
    '& .ql-editor': {
      height: 200,
    },
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  [`& .${classes.spacing}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const RegFormMail = props => {
  const { className, fields, regForm, save, ...rest } = props;
  const appContext = useContext(AppContext);
  const { mid: meetupId } = useParams();

  const form = useForm();

  const handleSave = data => {
    save(data, form);
  };

  const handleTestMail = () => {
    form.handleSubmit(data => {
      appContext.configApi
        .sendTestEmail(meetupId, data.completionMailTemplate)
        .then(({ data }) => {
          alert('Письмо отправлено на адрес: ' + data.to);
        })
        .catch(error => {
          const data = error.response.data;
          alert('Ошибка отправки: ' + JSON.stringify(data));
        });
    })();
  };

  return (
    <StyledCardBlock title={'Письмо подтверждения'} form={form} save={handleSave}>
      <Grid container spacing={0} sx={{ margin: '-4px' }}>
        <Grid className={classes.groupLabel} size={4}>
          <Typography>Отправлять письмо при регистрации:</Typography>
        </Grid>
        <Grid size={8}>
          {fields.filter(e => e.systemField === 'email').length !== 0 ? (
            <ECCheckboxField label='Отправлять' name='sendCompletionEmail' initial={regForm} form={form} />
          ) : (
            <>
              <ECCheckboxField
                label='Отправлять'
                name='sendCompletionEmail'
                initial={regForm}
                form={form}
                disabled={true}
              />
              <Typography>
                Отправлять письма можно только при наличии поля email в профиле посетителя. Добавить поле можно в{' '}
                <Link style={{ cursor: 'pointer' }} to={`/m/${meetupId}/settings`}>
                  Настройках полей
                </Link>
              </Typography>
            </>
          )}
        </Grid>

        <Grid className={classes.groupLabel} size={4}>
          <Typography>Заголовок письма:</Typography>
        </Grid>
        <Grid size={8}>
          <ECTextField label='' name='completionMailTemplate.title' initial={regForm} form={form} />
        </Grid>

        <Grid className={classes.groupLabel} size={4}>
          <Typography>Текст письма:</Typography>
        </Grid>
        <Grid size={8}>
          <Paper variant='outlined'>
            <ECQuillEditor
              label=''
              name='completionMailTemplate.body'
              initial={regForm}
              form={form}
              className={classes.editor}
            />
          </Paper>

          <Typography>
            Посмотреть&nbsp;
            <Link style={{ cursor: 'pointer' }} to={`/m/${meetupId}/template-params`} target={'_blank'}>
              список доступных подстановок
            </Link>
            &nbsp;в шаблоне
          </Typography>
        </Grid>

        <Grid className={classes.groupLabel} size={4}>
          <Typography>Вложения:</Typography>
        </Grid>
        <Grid className={classes.spacing} size={8}>
          <AttachmentsList initial={regForm} form={form} name='completionMailTemplate.attachments' />
        </Grid>

        <Grid className={classes.groupLabel} size={4}>
          <Typography>Тест:</Typography>
        </Grid>
        <Grid size={8}>
          <Button color='secondary' onClick={handleTestMail}>
            Отправить тестовое письмо
          </Button>
        </Grid>
      </Grid>
    </StyledCardBlock>
  );
};

export default RegFormMail;
